export const THROTTLE_TIMEOUT = 400;
